import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { PermissionService } from '../services/permission.service';

/** Redirects `/` to the user's default allowed route. */
@Injectable({
  providedIn: 'root',
})
export class DefaultRouteGuard implements CanActivate {
  constructor(
    private permissionService: PermissionService,
    private router: Router
  ) {}

  canActivate(): UrlTree {
    return this.router.parseUrl(this.permissionService.getDefaultRoute());
  }
}
